import { AppState } from '@client/common/redux/store';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CartQuantityItem {
    sku: string;
    quantity: number;
    attemptedQuantity: number;
}

interface CartQuantityState {
    items: Record<string, CartQuantityItem>;
}

const initialState: CartQuantityState = {
  items: {},
};

const NAME = 'cartQuantity';

export const cartQuantitySlice = createSlice({
  name: NAME,
  reducerPath: NAME,
  initialState,
  reducers: {
    setItemQuantity: (state, action: PayloadAction<{ sku: string, quantity: number, attemptedQuantity: number }>) => {
      const { sku, quantity, attemptedQuantity } = action.payload;
      state.items[sku] = {
        sku,
        quantity,
        attemptedQuantity,
      };
      return state;
    },
    incrementItemQuantity: (state, action: PayloadAction<{ sku: string, amount?: number }>) => {
      const { sku, amount = 1 } = action.payload;
      const currentItem = state.items[sku] || { sku, quantity: 0, attemptedQuantity: 0 };
      const newQuantity = currentItem.quantity + amount;

      state.items[sku] = {
        ...currentItem,
        quantity: newQuantity,
        attemptedQuantity: newQuantity,
      };

      return state;
    },
    clearItems: (state) => {
      state.items = {};
      return state;
    },
  },
});

export const {
  setItemQuantity,
  incrementItemQuantity,
  clearItems,
} = cartQuantitySlice.actions;

const getState = (state: AppState) => state.cart.cartQuantity;

export const selectCartQuantityItems = createSelector(
  [getState],
  (state) => state.items,
);

export const selectCartQuantityItemBySku = createSelector(
  [selectCartQuantityItems, (state, sku: string) => sku],
  (items, sku) => items[sku],
);
